import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";

const axios = require("axios").default;

const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password must be a minimum of 6 characters")
    .max(30, "Password must be under 30 characters")
    .required("Password is required"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

function ResetPassword() {
  let params = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [serverError, setServerError] = useState("");
  const [serverSuccess, setSuccess] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    axios
      .post(
        "https://application-flashcards.herokuapp.com/api/users/checkemailtoken",
        {
          token: params.token,
        }
      )
      .then((resp) => {
        setEmail(resp.data.decodedEmail);
      })
      .catch((err) => {
        console.log(err);
        setServerError(err.response.data.error);
      });
  }, []);

  return (
    <div className="h-screen flex items-center pb-32">
      {serverError || serverSuccess ? (
        <div className="font-bold text-center border border-slate-300 w-5/12 rounded-sm p-5 px-10 m-auto py-5 sm:w-10/12 md:w-8/12 md:px-5 md:mx-auto xl:w-6/12">
          <p>{serverError}</p>
          <div>
            <p className="mb-2">{serverSuccess}</p>

            {serverSuccess ? (
              <button
                onClick={(e) => {
                  e.preventDefault();

                  navigate("/login");
                }}
                className="font-normal text-white bg-green-400 border-solid border border-neutral-50 rounded px-3 py-1 hover:bg-green-500"
              >
                Login
              </button>
            ) : null}
          </div>
        </div>
      ) : (
        <Formik
          initialValues={{
            password: "",
            confirmPassword: "",
          }}
          validationSchema={ResetPasswordSchema}
          onSubmit={(values) => {
            axios
              .post(
                "https://application-flashcards.herokuapp.com/api/users/resetpassword",
                {
                  ...values,
                  token: params.token,
                  email: email,
                }
              )
              .then(function (response) {
                setSuccess(response.data.success);
              })
              .catch(function (error) {
                console.log(error.response.data.message);
                setError(error.response.data.message);
              });
          }}
        >
          {({ errors, touched }) => (
            <Form className="border border-slate-300 w-5/12 rounded-sm p-5 px-20 m-auto py-10 sm:w-10/12 md:w-8/12 md:px-5 md:mx-auto xl:w-6/12">
              <h2 className="text-2xl font-semibold mb-2 text-stone-700">
                Reset Password
              </h2>
              <div className="flex justify-between">
                <label for="password" className="my-2">
                  Password:
                </label>
                {errors.password && touched.password ? (
                  <p className="pt-2 text-md font-thin text-red-500">
                    {errors.password}
                  </p>
                ) : null}
              </div>
              <Field
                id="password"
                placeholder=" Enter New Password Here"
                type="password"
                name="password"
                className="border border-slate-400 py-1 w-full"
              />
              <div className="flex justify-between">
                <label for="confirmPassword" className="my-2">
                  Confirm Password:
                </label>
                {errors.confirmPassword && touched.confirmPassword ? (
                  <p className="pt-2 text-md font-thin text-red-500">
                    {errors.confirmPassword}
                  </p>
                ) : null}
              </div>
              <Field
                id="confirmPassword"
                placeholder=" Confirm New Password Here"
                type="password"
                name="confirmPassword"
                className="border border-slate-400 py-1 w-full"
              />
              {error ? (
                <p className="pt-2 text-md font-thin text-red-500">
                  Server Error: {error}
                </p>
              ) : null}
              <div className="flex justify-end mt-1">
                <button
                  className="text-white bg-sky-400 border-solid border border-neutral-50 rounded p-1 hover:bg-sky-500"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      )}

      <div
        className="absolute bottom-0 py-12 flex justify-center w-full text-3xl font-semibold"
        style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
      >
        <button
          onClick={() => {
            navigate("/login");
          }}
        >
          flashcards
        </button>
      </div>
    </div>
  );
}

export default ResetPassword;
